export default __webpack_public_path__ + "static/media/warning--wombat-crossing--g1.633523a4.png";